import styled from '@grebban/style-system-react';
import Text from 'components/Text';
import React from 'react';
import { above } from '@sportson/core-web/utils/mediaqueries';
import Link from '@sportson/core-web/components/Link';

const Wrapper = styled('section')`
    padding: 0px 12px;
    ${above['desktop.sm']} {
        padding: 0px 40px;
    }
`;
const LinksWrapper = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

const AlphabetSection = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 40px 12px;
    border-top: 1px solid var(--color-neutrals-200);

    ${above['desktop.sm']} {
        flex-direction: row;
        align-items: flex-start;
        gap: 24px;
    }
`;
const Letter = styled(Text)`
    line-height: 100%;

    ${above['desktop.sm']} {
        width: 33%;
    }
`;

const LinkItem = styled(Link)`
    color: var(--color-neutrals-500);
`;

interface BrandsListProps {
    lettersWithBrands: any;
}

export const BrandsList: React.FC<BrandsListProps> = ({ lettersWithBrands }) => (
    <Wrapper>
        {lettersWithBrands.map(({ letter, brands }) => {
            if (!brands.length) {
                return null;
            }
            return (
                <AlphabetSection key={`${letter}`}>
                    <Letter typography="Content/32_120_0_500">{letter}</Letter>
                    <LinksWrapper>
                        {brands
                            .filter((brand) => brand.ancestors?.length <= 1)
                            .sort((a, b) => a.title.localeCompare(b.title))
                            .map((brand) => (
                                <LinkItem to={brand.url} key={`${brand.url}_${brand.title}`}>
                                    <Text typography="UI/20_100_0_450">{brand.title}</Text>
                                </LinkItem>
                            ))}
                    </LinksWrapper>
                </AlphabetSection>
            );
        })}
    </Wrapper>
);

export default BrandsList;
